import { render, staticRenderFns } from "./space-guide.vue?vue&type=template&id=0b2260d3&scoped=true&"
import script from "./space-guide.vue?vue&type=script&lang=js&"
export * from "./space-guide.vue?vue&type=script&lang=js&"
import style0 from "./space-guide.vue?vue&type=style&index=0&id=0b2260d3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2260d3",
  null
  
)

export default component.exports